import Modal from '@libs/Modal';

import T_modal from '../../tpl/modals/quoteOptions.html';

import CE_QuoteOption from '../libs/customElement/QuoteOption';

import QuoteOption from '../libs/QuoteOptions';

class QuoteOptionsModal extends Modal {
	constructor() {
		super({
			tpl: T_modal,
			keyboard: false,
			backdrop: 'static'
		});

		this.on('opened', async () => {
			const quoteOption = QuoteOption.getInstance();

			const N_quoteOption = this.element.querySelector(CE_QuoteOption.tagName) as CE_QuoteOption;

			N_quoteOption.setParentElement(this.element);

			N_quoteOption.quoteOptions = quoteOption.quoteOptions;
			N_quoteOption.data = quoteOption.pref;

			const N_save = this.element.querySelector('#save') as HTMLButtonElement;

			N_save.addEventListener('click', () => {
				this.resolve(N_quoteOption.data);
			});
		});
	}
}

export default QuoteOptionsModal;
